import { useCallback, useState } from 'preact/hooks'
import { HintContent, HintSiteConfig, InlineNotice } from '../types'
import { useStepsManager } from './useStepsManager'

export const useManagerV2 = (config: HintSiteConfig) => {
  const stepsManager = useStepsManager(config.steps)
  const submitKeywordFromSteps = stepsManager.submitKeyword
  const resetSubmitErrorFromSteps = stepsManager.resetSubmitError
  const [userDefinedInlineNotice, setUserDefinedInlineNotice] = useState<
    InlineNotice | undefined
  >(undefined)

  const [modalContent, setModalContent] = useState<HintContent[] | undefined>(
    undefined
  )

  const submitKeyword = useCallback(
    (val: string) => {
      const reactionConfigs = config.reactions.filter((reaction) =>
        reaction.keywords.includes(val)
      )

      const unlockedReaction = reactionConfigs.length > 0

      for (const reactionConfig of reactionConfigs) {
        if (reactionConfig.reaction.type === 'inlineNotice') {
          setUserDefinedInlineNotice(reactionConfig.reaction)
        }

        if (reactionConfig.reaction.type === 'modal') {
          setModalContent(reactionConfig.reaction.contents)
        }
      }

      const unlockedStep = submitKeywordFromSteps(val, {
        suppressError: unlockedReaction,
      })

      return unlockedStep || unlockedReaction
    },
    [config.reactions, submitKeywordFromSteps]
  )

  const resetSubmitError = useCallback(() => {
    setUserDefinedInlineNotice(undefined)
    resetSubmitErrorFromSteps()
  }, [resetSubmitErrorFromSteps])

  const closeModal = useCallback(() => {
    setModalContent(undefined)
  }, [setModalContent])

  return {
    currentStep: stepsManager.currentStep,
    currentStepKey: stepsManager.currentStepKey,
    setCurrentStepKey: stepsManager.setCurrentStepKey,
    keywordSubmitError: stepsManager.keywordSubmitError,
    userDefinedInlineNotice,
    submitKeyword,
    resetSubmitError,
    visibleButtons: stepsManager.visibleButtons,
    modalContent,
    closeModal,
  } as const
}
